import { ProductDetailViewEvent, ProductDetailViewEventFku } from '@/usecases/event-bus-for-third-party/events/product-detail'

export function handleProductDetailViewEvent(event: ProductDetailViewEvent): void {
  const products = event.fku.reduce(
    (acc: CyberAceProductItem[], fku: ProductDetailViewEventFku): CyberAceProductItem[] => [
      ...acc,
      ...fku.sku.map(sku => ({
        id: sku.id,
        short_id: sku.short_id,
        name: event.root.name,
        price: sku.price,
        brand: event.root.brand,
        category: event.root.category.join(','),
      })),
    ],
    []
  )
  /**
   * CyberACE用
   * このイベントは送信なくて良いかも知れない
   * - CyberACEは過去SMbrandで契約していたが、現在は契約解除しているはずなので送信しなくていいかも
   * - MyColor以外のホストでも送信しているが、参照されていないことが確認できれば送信しなくていいかも
   *
   * @see https://my-color.esa.io/posts/1259
   * @see https://github.com/Everforth/growthpalette-front/issues/8144
   */
  window.dataLayer.push({
    pageType: 'productDetail',
    ecommerce: {
      detail: {
        products,
      },
    },
  })
}

interface CyberAceProductItem {
  id: string
  short_id: string
  name: string
  price: number
  brand: string
  category: string
}
